<template>
  <div class="mainDiv" v-if="userData">
    <div class="icon-section">
      <img
     
        width="80%"
        style="border-radius: 50%;"
        :src="userData.image?userData.image.original:'https://farmstock-assets.s3.amazonaws.com/base/defaultimage/904bdpc9S0aKWdGDzqSIig.png'"
        alt=""
      />
      
    </div>
    <div class="details">
      <div class="firstColumn">
        <div class="upperPart">
          <p class="columnText">{{ userData.name }}</p>
        </div>
        <!-- <div class="lowerPart">
                    <p class="columnHeader">Profile Link</p>
                    <p class="columnText">{{ this.user[0].profile_link }}</p>
                </div> -->
      </div>
      <div class="secondColumn">
        <div class="upperPart">
          <p class="columnText">{{ userData.acquisition_date }}</p>
        </div>
        <!-- <div class="lowerPart">
                    <p class="columnHeader">Current Business</p>
                    <p class="columnText">{{ this.user[0].current_business }}</p>
                </div> -->
      </div>
      <div class="lowerPart">
        <p class="columnText">{{ userData.district }}</p>
      </div>
      <div class="thirdColumn">
        <div class="upperPart">
          <p class="columnText">{{ userData.state }}</p>
        </div>
      </div>
      <div class="fourthColumn">
        <div class="upperPart">
          <p class="columnText">{{ userData.contact_number }}</p>
        </div>
        <!-- <div class="lowerPart">
                    <p class="columnHeader">Email ID</p>
                    <p class="columnText">{{ this.user[0].email }}</p>
                </div> -->
      </div>
    </div>
    <div class="seeprofilediv" @click="handleRoute(userData.id) ">
      <p class="seeprofiletext">See Profile</p>
      <img
        width="24px "
        height="24px"
        src="../../../../assets/nextArrow.svg"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import router from '../../../../router';
export default {
  name: "userListCard",
  props: {
    userData: {
      default: null,
    },
  },
  data() {
    return {
      user: [
        {
          user_name: "Rahul Kumar",
          email: "rahulkumar1234@gmail.com",
          profile_link: "krishify.com/506rprNg9yp",
          acquisition_date: "02/04/2019",
          current_business: "Poultry",
          state: "Maharashtra",
          district: "Pune",
          contact_number: "9785632140",
        },
      ],
      totalCount: 0,
    };
  },
  components: {},

  methods: {
    handleRoute(id){
      router.push({ name: `user`,params: { id: id } })
    }
  },
};
</script>
<style lang="scss" scoped>
.mainDiv {
  height: 72px;
  background: #fff !important;
  display: flex;
  padding-left: 24px;
  column-gap: 5%;
  margin-bottom: 10px;
}
.icon-section {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  //margin-right: 15px;

  img {
    width: 48px;
    height: 48px;
    border-radius: 4px;
  }
}
.imagediv {
  display: flex;
  width: 88px;
  height: 88px;

  justify-content: center;
}
.details {
  display: flex;
  width: 90%;
  column-gap: 5%;
  align-items: center;
}
.firstColumn {
  width: 15%;
}
.secondColumn {
  width: 15%;
}
.thirdColumn {
  width: 15%;
}
.fourthColumn {
  width: 15%;
}
.upperPart {
  width: 100%;
}
.lowerPart {
  width: 10%;
}
.columnHeader {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  margin-top: 0px;
  margin-bottom: 6px;
  color: rgba(121, 126, 121, 0.75);
}
.columnText {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  width: 95%;
  word-wrap: break-word;
  /* Greyscale/1 */

  color: #3a3f3a;
}
.seeprofilediv {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
  column-gap: 5%;
}
.seeprofiletext {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  margin-bottom: 0px;

  /* Main/Green */

  color: #189d3b;
}
</style>
